export const createIsHeaderStaticProjection = () => {
  return `"isHeaderStatic": count(pageBuilder[_type == 'sectionProgressIndicator']) > 0`
}
